import * as React from 'react';
import { useToken } from '../hooks';
import { OwnUserWithCompany } from 'services/resolvers/Common';
import { useProperties } from 'controller/CommonService';

export type AppContextType = {
    appToken: string | undefined;
    setAppToken: (token: string | undefined, localStorage?: boolean) => void;
    isLoggedIn: boolean;
    titleReplacements: Record<string, string>;
    setTitleReplacements: (titleReplacements: Record<string, string>) => void;
    ownUser: OwnUserWithCompany | null;
    setOwnUser: (ownUser: OwnUserWithCompany | null) => void;
    propertyManager: ReturnType<typeof useProperties>;
};

export const AppContext = React.createContext<AppContextType | null>(null);

interface Props {
    children: React.ReactNode;
}

export const AppContextProvider: React.FC<Props> = ({ children }) => {
    const [titleReplacements, setTitleReplacements] = React.useState<Record<string, string>>({});
    const [ownUser, setOwnUser] = React.useState<OwnUserWithCompany | null>(null);
    const { token: appToken, setToken: setAppToken, isLoggedIn } = useToken();
    const propertyManager = useProperties();

    return (
        <AppContext.Provider
            value={{
                appToken,
                setAppToken,
                isLoggedIn,
                titleReplacements,
                setTitleReplacements,
                ownUser,
                setOwnUser,
                propertyManager
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export default AppContext;
